var _ellipse, _path, _mask, _g, _path2, _path3, _mask2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.848,
    cy: 27.454,
    fill: "#FFDA8E",
    rx: 22.44,
    ry: 22.318
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDAE00",
    fillRule: "evenodd",
    d: "M41.907 27.939c0-2.97-1.237-5.995-2.2-7.838 0 0-1.017-2.365-1.017-3.465v-.577h-7.865v.577c0 1.1-1.018 3.465-1.018 3.465-.935 1.843-2.2 4.84-2.2 7.838v21.285h14.245c.055-3.465.055-17.133.055-21.285z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 9,
    height: 5,
    x: 30,
    y: 12,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30.852 12.895h7.865v3.19h-7.865v-3.19z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M38.717 12.895h-7.865v3.19h7.865v-3.19z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M29.12 47.85V28.956c0-3.08 1.402-6.325 2.254-7.975l.028-.055.027-.055c.165-.385.88-2.118 1.155-3.52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M29.12 49.635h12.76V27.937c0-2.97-1.237-5.995-2.2-7.838 0 0-1.017-2.364-1.017-3.465v-3.74h-7.81v3.768c0 1.1-1.018 3.465-1.018 3.465-.935 1.843-2.2 4.84-2.2 7.838v19.91c.028-.028-.275 1.76 1.485 1.76z",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 56,
    height: 56,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.5 57.5h55v-55h-55v55z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M40.092 13.144c0 .412-.33.77-.77.77h-9.13a.769.769 0 01-.77-.77v-1.128c0-.412.33-.77.77-.77h9.157c.413 0 .77.33.77.77v1.128h-.027z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M40.092 13.144c0 .412-.33.77-.77.77h-9.13a.769.769 0 01-.77-.77v-1.128c0-.412.33-.77.77-.77h9.157c.413 0 .77.33.77.77v1.128h-.027z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#708E07",
    fillRule: "evenodd",
    d: "M33.383 27.277a11.83 11.83 0 00-6.188 7.92h8.69a11.46 11.46 0 00-2.502-7.92z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M33.383 27.277a11.83 11.83 0 00-6.188 7.92h8.69a11.46 11.46 0 00-2.502-7.92z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M29.285 33.685a10.17 10.17 0 013.658-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D23F4E",
    fillRule: "evenodd",
    d: "M29.175 33.462a5.638 5.638 0 11-11.275 0 5.638 5.638 0 0111.275 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M29.175 33.462a5.638 5.638 0 11-11.275 0 5.638 5.638 0 0111.275 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M23.537 37.59a4.12 4.12 0 01-4.125-4.125 4.12 4.12 0 014.125-4.125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94C01E",
    fillRule: "evenodd",
    d: "M25.16 36.327a11.622 11.622 0 00-5.17-7.398c-.027-.082-.027-.137-.027-.192a11.803 11.803 0 00-6.215-8.003 11.753 11.753 0 00-2.393 9.13c-1.017-.467-2.062-.797-3.162-.935a11.755 11.755 0 00.935 10.065 11.807 11.807 0 008.415 5.638c.33-.88.523-1.788.633-2.695a11.811 11.811 0 004.675 4.262 11.822 11.822 0 002.31-9.872z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M25.16 36.327a11.622 11.622 0 00-5.17-7.398c-.027-.082-.027-.137-.027-.192a11.803 11.803 0 00-6.215-8.003 11.753 11.753 0 00-2.393 9.13c-1.017-.467-2.062-.797-3.162-.935a11.755 11.755 0 00.935 10.065 11.807 11.807 0 008.415 5.638c.33-.88.523-1.788.633-2.695a11.811 11.811 0 004.675 4.262 11.822 11.822 0 002.31-9.872z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M12.867 29.613c-.358-2.392.11-4.84 1.347-6.875M10.447 38.195c-1.348-2.282-1.788-4.977-1.183-7.535.495.138.99.33 1.485.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E4E6",
    fillRule: "evenodd",
    d: "M37.727 35.008H5.938c0 5.857 2.53 11.11 6.518 14.74h18.782c3.988-3.658 6.49-8.91 6.49-14.74z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M37.727 35.008H5.938c0 5.857 2.53 11.11 6.518 14.74h18.782c3.988-3.658 6.49-8.91 6.49-14.74z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.003,
    d: "M30.604 48.203H13.032c-3.218-3.107-5.17-7.26-5.555-11.715"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E6940",
    fillRule: "evenodd",
    d: "M52.825 41.219v.907c0 .88-.743 1.623-1.623 1.623H30.605c-.88 0-1.623-.743-1.623-1.623v-2.255h23.843v1.513",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.926,
    d: "M52.825 41.219v.907c0 .88-.743 1.623-1.623 1.623H30.605c-.88 0-1.623-.743-1.623-1.623v-2.255h23.843v1.513"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60C684",
    fillRule: "evenodd",
    d: "M52.495 39.375H28.983c-.798 0-1.458.66-1.458 1.513v1.76c.385.027.798-.138 1.018-.55l.357-.633a1.03 1.03 0 01.468-.44c.467-.22 1.1-.082 1.402.44l.358.632c.412.715 1.457.715 1.842 0l.358-.632c.412-.715 1.457-.715 1.842 0l.358.632c.412.715 1.457.715 1.842 0l.358-.632c.412-.715 1.457-.715 1.842 0l.358.632c.412.715 1.457.715 1.842 0l.358-.632c.412-.715 1.457-.715 1.842 0l.358.632c.412.715 1.457.715 1.842 0l.358-.632c.412-.715 1.457-.715 1.842 0l.358.632c.412.715 1.457.715 1.842 0l.358-.632a1.067 1.067 0 011.485-.385c.137.083.275.22.357.385l.358.632c.192.33.522.523.852.55v-1.814c-.027-.798-.687-1.458-1.485-1.458z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.926,
    d: "M52.495 39.375H28.983c-.798 0-1.458.66-1.458 1.513v1.76c.385.027.798-.138 1.018-.55l.357-.633a1.03 1.03 0 01.468-.44c.467-.22 1.1-.082 1.402.44l.358.632c.412.715 1.457.715 1.842 0l.358-.632c.412-.715 1.457-.715 1.842 0l.358.632c.412.715 1.457.715 1.842 0l.358-.632c.412-.715 1.457-.715 1.842 0l.358.632c.412.715 1.457.715 1.842 0l.358-.632c.412-.715 1.457-.715 1.842 0l.358.632c.412.715 1.457.715 1.842 0l.358-.632c.412-.715 1.457-.715 1.842 0l.358.632c.412.715 1.457.715 1.842 0l.358-.632a1.067 1.067 0 011.485-.385c.137.083.275.22.357.385l.358.632c.192.33.522.523.852.55v-1.814c-.027-.798-.687-1.458-1.485-1.458z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5BE80",
    fillRule: "evenodd",
    d: "M46.638 31.348H35.611c-3.328 0-6.215 2.337-7.645 5.72-.468 1.1.192 2.392 1.21 2.392h23.87c1.017 0 1.677-1.292 1.21-2.392-1.403-3.383-4.29-5.72-7.618-5.72z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.926,
    d: "M46.638 31.348H35.611c-3.328 0-6.215 2.337-7.645 5.72-.468 1.1.192 2.392 1.21 2.392h23.87c1.017 0 1.677-1.292 1.21-2.392-1.403-3.383-4.29-5.72-7.618-5.72z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    fillRule: "evenodd",
    d: "M35.445 33.823c0 .248-.22.468-.495.468s-.495-.22-.495-.468c0-.248.22-.468.495-.468s.495.22.495.468zM37.838 36.132c0 .247-.22.467-.495.467s-.495-.22-.495-.467c0-.248.22-.468.495-.468.275.028.495.22.495.468zM41.963 34.757c0 .247-.22.467-.495.467s-.495-.22-.495-.467c0-.248.22-.468.495-.468s.495.22.495.468zM45.675 37.48c0 .247-.22.467-.494.467-.275 0-.495-.22-.495-.468 0-.247.22-.467.495-.467s.495.192.495.467zM48.123 36.382a.482.482 0 01-.495.467.482.482 0 01-.495-.467c0-.259.221-.468.495-.468.273 0 .495.21.495.468zM49.222 33.96c0 .247-.22.467-.495.467s-.495-.22-.495-.467c0-.248.22-.468.495-.468.275.028.495.22.495.468zM52.082 36.6c0 .248-.22.468-.495.468s-.495-.22-.495-.468c0-.247.22-.467.495-.467s.495.22.495.467zM32.502 36.846c0 .248-.22.468-.495.468s-.495-.22-.495-.468c0-.247.22-.467.495-.467s.495.22.495.467zM44.933 33.053a.482.482 0 01-.495.468.482.482 0 01-.495-.468c0-.258.222-.467.495-.467.274 0 .495.21.495.467z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5BE80",
    fillRule: "evenodd",
    d: "M51.863 49.91H29.918a2.03 2.03 0 01-2.035-2.035 2.03 2.03 0 012.035-2.035h21.917a2.03 2.03 0 012.035 2.035c.028 1.1-.907 2.035-2.007 2.035z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.926,
    d: "M51.863 49.91H29.918a2.03 2.03 0 01-2.035-2.035v0a2.03 2.03 0 012.035-2.035h21.917a2.03 2.03 0 012.035 2.035v0c.028 1.1-.907 2.035-2.007 2.035z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8AE46",
    fillRule: "evenodd",
    d: "M53.127 43.75h-24.42a1.045 1.045 0 100 2.09h24.42c.578 0 1.045-.468 1.045-1.045.028-.578-.467-1.045-1.045-1.045z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#575756",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.001,
    d: "M53.127 43.75h-24.42a1.045 1.045 0 100 2.09h24.42c.578 0 1.045-.468 1.045-1.045.028-.578-.467-1.045-1.045-1.045z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.688,
    d: "M29.395 46.75h22.192M28.982 44.438H52.55M35.115 32.227H47.05"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.23c39d8fa34ca66b4ec8c5e12c66852b.svg";
export { ForwardRef as ReactComponent };